import styled from "styled-components";
import { colors } from "../../../../styles/colors";

export const MediaPreviewContainer = styled.div`
  width: 300px;
  height: 300px;
  margin: 16px auto;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors.darkBlueAlpha80};
  border: 1px solid ${colors.blueGrayAlpha80};

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
`;

export const MediaPreviewName = styled.div`
  font-size: 14px;
  color: #666;
  text-align: center;
  margin: 8px auto 0;
  word-break: break-all;
  max-width: 300px;
`;
